export default "__VITE_ASSET__BbbisF4U__"